<template>
  <div class="container">
    <header>
      <div class="title-banner">
        <h1 class="gb-page-title">Learning Goal Index</h1>
        <p class="title-subheading">Explore all learning goals, objectives, and progress monitoring resources by subject area.</p>
      </div>
    </header>
    <main>
      <div class="collapse-expand-actions text-right text-muted">
        <small>
          <button class="btn btn-link link-button" @click="collapseAll">Collapse all</button> | <button class="btn btn-link link-button" @click="expandAll">Expand all</button>
        </small>
      </div>
      <div class="row">
        <div
          v-for="(column,i) in subjectColumns"
          :key="'subject-column-' + i"
          class="col-md-4">
          <GoalIndexSubject
            v-for="subject in column"
            :key="subject.subject"
            :subject="subject"
            :expanded="expanded[subject.subject]"
            @update:expanded="updateExpanded"
          />
        </div>
      </div>
    </main>
    <SubmitFeedback
      type="Goal Index"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GoalIndexSubject from '@/components/goalindex/GoalIndexSubject'
import SubmitFeedback from '@/components/SubmitFeedback'
export default {
	name: 'GoalIndexPage',
	components: {
    GoalIndexSubject,
    SubmitFeedback,
  },
  data() {
    return {
      expanded: {}
    }
  },
  computed: {
    ...mapGetters({
      contentProfileSubjects: 'contentProfile/publishedSubjects',
    }),
    contentSubjects() {
      return this.contentProfileSubjects
    },
    subjectColumns() {
      let columns = []
      if (this.contentSubjects && this.contentSubjects.length) {
        let subjectsLength = this.contentProfileSubjects.length
        let colLength = Math.ceil(subjectsLength / 3)

        for (let i=0; i<=subjectsLength; i+=colLength) {
          let column = this.contentProfileSubjects.slice(i, i + colLength)
          columns.push(column)
        }
      }
      return columns
    }
  },
  methods: {
    updateExpanded(subjectName, expanded) {
      this.expanded[subjectName] = expanded
    },
    expandAll() {
      this.$sendEvent(
        'Toggled LGI Subject',
        {
          lgi_subject: 'all',
          lgi_expanded: true
        })
      Object.keys(this.expanded).forEach(key => this.expanded[key] = true)
    },
    collapseAll() {
      this.$sendEvent(
        'Toggled LGI Subject',
        {
          lgi_subject: 'all',
          lgi_expanded: false
        })
      Object.keys(this.expanded).forEach(key => this.expanded[key] = false)
    },
    setExpanded() {
      let expanded = {}
      this.contentSubjects.forEach(subject => {
        expanded[subject.subject] = this.expanded[subject.subject] || true
      })
      this.expanded = expanded
    },
  },
  mounted() {
    this.setExpanded()
  },
  created() {
    this.$sendEvent(
      'Viewed Learning Goal Index Page',
      {
        ref: this.$route.query.ref
      }
    )
  },
  watch: {
    contentSubjects() {
      this.setExpanded()
    }
  },
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
}
.btn-link {
  font-size: 12px;
  padding: 0;
  outline-offset: 4px;
}
</style>